import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { PercPipe } from '../../../../../pipes/perc.pipe';
import { User } from '../../../../../models/User';
import { CustomItemContext } from 'app/components/data-table/data-table.component';
import { PieChartData } from '../../../charts/models/PieChartData';

@Component({
  selector: 'domain-device-distribution',
  templateUrl: './device-distribution.html',
  styleUrls: ['./device-distribution.css']
})
export class DeviceDistribution implements AfterViewInit {
  @Input() domain;
  @Input() data: any;
  @Input() month;
  @Input() isFollowing: boolean;
  @Output() anchorClick: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('osTemplate') osTemplate: TemplateRef<CustomItemContext>;
  @ViewChild('lockedTemplate') lockedTemplate: TemplateRef<CustomItemContext>;
  @ViewChild('totalTrafficRatioTemplate')
  totalTrafficRatioTemplate: TemplateRef<CustomItemContext>;

  toggle1 = false;
  toggle2 = false;

  desktopData = [];
  desktopHeaders = [];
  mobileData = [];
  mobileHeaders = [];
  percPipe = new PercPipe();
  devicePieChartData: Array<PieChartData> = [];
  desktopPieChartData: Array<PieChartData> = [];
  mobilePieChartData: Array<PieChartData> = [];

  get isFreemium(): boolean {
    return this.userService.isFreemium();
  }

  constructor(private userService: User) {}

  toggle(n) {
    this['toggle' + n] = !this['toggle' + n];
  }

  ngAfterViewInit() {
    this.desktopData = this.data['deviceDistribution']['desktopData'];
    if (this.desktopData) {
      // <!--<div class="col-md-6 col-lg-6"><strong>OS Name</strong></div>-->
      // <!--<div class="col-md-6 col-lg-6 text-xs-right"><strong>Contribution %</strong></div>-->
      this.desktopHeaders.push({
        class: 'col-4',
        text: 'OS NAME',
        key: 'os',
        tooltipkey: ''
      });
      this.desktopHeaders.push({
        class: 'col text-right',
        text: 'CONTRIBUTION %',
        key: 'totalTrafficRatio',
        tooltipkey: ''
      });

      this.prepareHTML(this.desktopData);
    }
    this.mobileData = this.data['deviceDistribution']['mobileData'];
    if (this.mobileData) {
      this.mobileHeaders.push({
        class: 'col-4',
        text: 'OS NAME',
        key: 'os',
        tooltipkey: ''
      });
      this.mobileHeaders.push({
        class: 'col text-right',
        text: 'CONTRIBUTION %',
        key: 'totalTrafficRatio',
        tooltipkey: ''
      });

      this.prepareHTML(this.mobileData);
    }

    if (this?.data?.deviceDistribution?.deviceTypes) {
      this.devicePieChartData = this?.data?.deviceDistribution?.deviceTypes.map(
        item => {
          return {
            category: item?.deviceType,
            value: item?.totalTrafficRatio, //parseFloat((item?.totalTrafficRatio * 100).toString()).toFixed(2),
            title: item?.deviceType
          };
        }
      );
    }

    if (this?.data?.deviceDistribution?.desktopData) {
      this.desktopPieChartData =
        this?.data?.deviceDistribution?.desktopData.map(item => {
          return {
            category: item?.os,
            value: parseFloat(
              (item?.totalTrafficRatio * 100).toString()
            ).toFixed(2),
            title: item?.os
          };
        });
    }

    if (this?.data?.deviceDistribution?.mobileData) {
      this.mobilePieChartData = this?.data?.deviceDistribution?.desktopData.map(
        item => {
          return {
            category: item?.os,
            value: parseFloat(
              (item?.totalTrafficRatio * 100).toString()
            ).toFixed(2),
            title: item?.os
          };
        }
      );
    }
  }

  prepareHTML(data) {
    for (const osData of data) {
      // <img width="18" heigh="18" *ngIf="osData.osShortName != 'Unknown'"
      // src="images/os_icon_{{osData.osShortName}}.png"> {{osData.os}}-->
      const osShortName = osData['osShortName'];
      if (osShortName !== 'Unknown') {
        osData['osTemplate'] = this.osTemplate;
      }
      // {{osData.totalTrafficRatio | perc:'1.2-2'}}
      if (this.isFreemium) {
        osData['totalTrafficRatioTemplate'] = this.lockedTemplate;
      } else {
        const totalTrafficRatio = osData['totalTrafficRatio'];
        osData['totalTrafficRatioTemplate'] = this.totalTrafficRatioTemplate;
      }
    }
  }
}
